import PropTypes from 'prop-types';
import { DropdownSingleSelect } from '@leegality/leegality-react-component-library';

const SingleSelectDropDown = ({
  selectedId, itemList, onHandleSelect, onSelect, ...rest
}) => {
  const items = itemList.map((item) => ({
    ...item,
    selected: item.id === selectedId,
  }));

  const handleSelect = (id) => {
    if (onHandleSelect) {
      const selectedItem = items.find((item) => item.id === id);
      onHandleSelect(selectedItem);
    }
    onSelect(id);
  };

  return (
    <DropdownSingleSelect
      items={items}
      onSelect={handleSelect}
      {...rest}
    />
  );
};

SingleSelectDropDown.defaultProps = {
  selectedId: null,
  onHandleSelect: null,
  onSelect: () => {},
};

SingleSelectDropDown.propTypes = {
  itemList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  selectedId: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
  onHandleSelect: PropTypes.func,
  onSelect: PropTypes.func,
};

export default SingleSelectDropDown;
